import { connect } from 'react-redux';
import CashInConfirm from '../../../components/modals/CashInConfirm';
import { confirm, reject } from '../../../modules/cimb/actions';
import { getPrice, isRequestPending } from '../../../modules/cimb/selectors';

const mapStateToProps = state => ({
  price: getPrice(state),
  requestPending: isRequestPending(state)
});

const mapDispatchToProps = {
  confirm,
  reject
};

export default connect(mapStateToProps, mapDispatchToProps)(CashInConfirm);
